export default "__VITE_ASSET__DMtlmHGy__"